import { FC } from 'react';
import { Button, ButtonProps } from '../ui/button';
import FilterIcon from '../icons/FilterIcon';

type Props = {
	name: string;
	filtersQuantity: number;
	onClick: () => void;
	className?: string;
	isMobile?: boolean;
} & ButtonProps;

const EFilterButton: FC<Props> = ({name, filtersQuantity, onClick, className, isMobile = false}) => {
    return (
        <div className="relative">
            {!!filtersQuantity && (
                <div className="absolute -top-1 right-0 size-4 rounded-full bg-error-1000 flex items-center justify-center text-2xs text-popover-10 animate-pulse ">
                    {filtersQuantity}
                </div>
            )}
            <Button
                variant="outline"
                size={isMobile ? 'icon' : 'default'}
                onClick={onClick}
				className={className}
            >
                <FilterIcon />
                {!isMobile && name}
            </Button>
        </div>
    );
};

export default EFilterButton;
